import { useAppSSEEvents } from "@src/features/sse";
import { DashboardLayout as Layout } from "@src/pages/DashboardLayout";
import { useActor } from "@src/providers/actorProvider";
import { Outlet } from "react-router-dom";

export function meta() {
  return [
    { title: "Dashboard" },
    { name: "description", content: "Dashboard" },
  ];
}

export async function clientLoader() {
  return {};
}

export default function DashboardLayout({ onClose }: { onClose?: () => void }) {
  const actor = useActor();
  const userId = actor.user.id;

  useAppSSEEvents(userId, actor.type, {
    enabled: userId != null,
  });

  return (
    <Layout onClose={onClose}>
      <Outlet />
    </Layout>
  );
}
